import { Link, Outlet } from "@tanstack/react-router";
import { Button, LogoWordmark, Toaster, TooltipProvider } from "@atrix-analytics/ui";
import { useTheme } from "../lib/theme";

export function RootLayout() {
  const { pref } = useTheme();
  return (
    <TooltipProvider delayDuration={300}>
      <Outlet />
      <Toaster position="bottom-right" theme={pref} />
    </TooltipProvider>
  );
}

export function NotFound() {
  return (
    <main className="grid min-h-screen place-items-center px-4">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <LogoWordmark />
        <h1 className="mt-4 font-display text-xl font-semibold">Page not found</h1>
        <p className="text-sm text-fg-muted">That address doesn't match anything in Atrix Analytics.</p>
        <Button onClick={() => history.back()} variant="secondary">
          Go back
        </Button>
        <Link to="/" className="text-sm text-accent underline-offset-4 hover:underline">
          Go to your projects
        </Link>
      </div>
    </main>
  );
}
